<template>
	<main id="article">
		<div class="main">
      <dl class="titleTip">
        <dt>
          <span  style="color:#666;cursor: pointer" @click="$router.go(-1)">学术动态 ></span>
          <span> 学术动态详情</span>
        </dt>
        <dd></dd>
      </dl>
			<div class="mainBox" v-if="articleInfo">
				<h2>{{articleInfo.name}}</h2>
				<p class="time">{{articleInfo.time}}</p>
				<div class="content" v-html="articleInfo.richtext">
				</div>
			</div>
		</div>
	</main>
</template>
<style>
  #article .content * {
    line-height: 32px!important;
  }
</style>
<script>
  import $ from 'jquery'
	export default {
		name: 'Article',
		data() {
			return {
				name: '',
				time: '',
				content: '',
				articleId: '',
        articleList: [],
        articleInfo: null
			}
		},
		created() {
			const articleId = this.$route.query.articleId;
			this.articleId = articleId;
			this.getArticleDtails();
		},
		methods: {
      showImg(url) {
        var imgid = Math.random(),frameid = 'frameimg' + imgid;
        window['img'+imgid] = '<img id="img" src=\''+url+'\' />' +
          '<script>window.onload = function(){' +
          // 'parent.document.getElementById(\''+frameid+'\').width=document.getElementById(\'img\').width+\'px\';' +
          // 'parent.document.getElementById(\''+frameid+'\').height=document.getElementById(\'img\').height+\'px\';' +
          'let width=document.getElementById(\'img\').width;' +
          'parent.document.getElementById(\''+frameid+'\').width=\'100%\';' +
          'parent.document.getElementById(\''+frameid+'\').objectFit=\'cover\';' +
          'var root = document.querySelector("body");' +
          'var img = document.querySelector("img");' +
          'root.style.textAlign = "center";' +
          'img.style.maxWidth = "100%";' +
          'parent.document.getElementById(\''+frameid+'\').height=document.getElementById(\'img\').height + \'px\';' +
          'console.log(img.clientWidth / width)' +
          '}<'+'/script>';
        return '<iframe id="'+frameid+'" src="javascript:parent[\'img'+imgid+'\'];" frameBorder="0" scrolling="no" width="100%"></iframe>';
      },
      changeImg() {
        var imgs = document.querySelectorAll('.content img');
        // console.log(imgs)
        for(var i=0;i<imgs.length;i++){
          var data_src = $(imgs[i]).attr("data-src");
          if (!data_src) {
            return
          }
          var html = this.showImg(data_src);
          $(imgs[i]).replaceWith(html);
        }
      },
			getArticleDtails() {
				const articleId = this.articleId;
				const params = {
					articleId: articleId,
				}
				this.$api.getAllArticleListByLimit(params).then(r => {
					if (r.code === 1) {
            this.articleList = r.data.data;
            let o = this.articleList.find((v) => {
              return v.articleId == articleId
            })
            this.articleInfo = Object.assign({}, o)
            this.$nextTick(() => {
              this.changeImg()
            })
						// this.name = r.data.name;
						// this.time = r.data.time;
						// this.content = r.data.content;
					}
				})
			},
		},
		computed: {

		},
		watch: {

		},
	}

</script>
<style lang="scss" scoped>
	@import './Article.scss';
</style>
